//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByKey: (state, getters) => key => {
        return getters['all']
            .filter(form => form.id.includes(key))
    },

    byId: state => id => {
        return state.entities[id]
    },


}


